import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-walking': {
			// /walking-f/ob?safe&utm_source=FB&country=US&exp=web_ml_price_prediction~1
			// Test variant adds the "reason" screen via the ML onboarding funnel + ML intro pricing (US).
			funnel: {
				id: 'ob-female-activity-walking-ml',
				locale: ['en'],
			},
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_ml_price_prediction/walking_f'),
			},
		},
		'activity-female-tai-chi-walking-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-pr&exp=web_ml_price_prediction~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_ml_price_prediction/tai_chi_walking_f_pr'),
			},
		},
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_ml_price_prediction~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_ml_price_prediction/tai_chi_walking_f_v2'),
			},
		},
		'activity-male-chair-tai-chi-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi-al&exp=web_ml_price_prediction~1
			// Same product ladder as chair-tai-chi-m. No funnel swap (reason screen already present).
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_ml_price_prediction/chair_tai_chi_m_al'),
			},
		},
	},
]

export default config
